if(!customElements.get('collection-filters') && !customElements.get('collection-filters-tags')) {
  class CollectionFiltersAbstract extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.summary = this.querySelector('.summary');
      this.documentClickHandler = this.documentClick.bind(this);
      this.ajax = true;

      if(this.dataset.open) {
        this.showFilters();
      }
      this.form.addEventListener('submit', (e)=>{
        e.preventDefault();
        this.filterResults();
      });
      
      // Handle open filter button
      const openButton = document.querySelector('.open-filters');
      if(openButton) {
        openButton.addEventListener('click', ()=>{
          this.showFilters();
        });
      }
      
      // Handle close filter button
      const closeButton = this.querySelector('.close-filters');
      if(closeButton) {
        closeButton.addEventListener('click', ()=>{
          this.hideFilters();
        });
      }
      
      // Handle overlay click
      const overlay = this.querySelector('.filters-overlay');
      if(overlay) {
        overlay.addEventListener('click', ()=>{
          this.hideFilters();
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
    }

    documentClick(e) {
      const filtersPanel = this.querySelector('.filters-panel');
      if(filtersPanel && !filtersPanel.contains(e.target) && !e.target.closest('.open-filters')) {
        this.hideFilters();
      }
    }

    isOpen() {
      return this.classList.contains('open');
    }

    showFilters() {
      document.documentElement.style.setProperty('overflow', 'hidden');
      this.classList.add('open');
      setTimeout(()=>{
        document.addEventListener('click', this.documentClickHandler);
      }, 100);
    }

    hideFilters() {
      document.documentElement.style.removeProperty('overflow');
      this.classList.remove('open');
      document.removeEventListener('click', this.documentClickHandler);
    }
  }

  if(!customElements.get('collection-filters')) {
    class CollectionFilters extends CollectionFiltersAbstract {
      constructor() {
        super();

        this.querySelectorAll('input').forEach((option)=>{
          option.addEventListener('change', (e)=>{
            setTimeout(()=>{
              this.filterResults();
            }, 300);
          });
        });
        
        // Initialize filters from URL
        this.initFromURL();
        this.initSummary();
      }

      initFromURL() {
        try {
          // Extract filter parameters from current URL and set form values
          const params = new URLSearchParams(window.location.search);
          
          for (const [key, value] of params) {
            if (key.startsWith('filter.') && value) {
              this.processURLFilterParam(key, value);
            }
          }
        } catch (error) {
          console.warn('Error initializing from URL:', error);
        }
      }

      processURLFilterParam(key, value) {
        try {
          // Handle multiple values separated by commas
          const values = value.split(',').map(v => v.trim()).filter(Boolean);
          
          values.forEach(val => {
            // Try multiple decoding strategies
            const decodingStrategies = [
              val,
              decodeURIComponent(val),
              decodeURI(val)
            ];
            
            let inputFound = false;
            for (const decodedVal of decodingStrategies) {
              if (this.setInputValue(key, decodedVal)) {
                inputFound = true;
                break;
              }
            }
            
            if (!inputFound) {
              console.debug('No input found for filter:', key, val);
            }
          });
        } catch (error) {
          console.warn('Error processing URL filter param:', key, value, error);
        }
      }

      setInputValue(key, value) {
        try {
          // Multiple selector strategies for better matching
          const selectors = [
            `input[name="${key}"][value="${value}"]`,
            `input[name="${key}"][value="${value.replace(/"/g, '\\"')}"]`
          ];
          
          for (const selector of selectors) {
            try {
              const inputs = this.querySelectorAll(selector);
              let foundMatch = false;
              
              inputs.forEach(input => {
                if (input.value === value) {
                  if (input.type === 'checkbox' || input.type === 'radio') {
                    input.checked = true;
                    foundMatch = true;
                  } else {
                    input.value = value;
                    foundMatch = true;
                  }
                }
              });
              
              if (foundMatch) {
                return true;
              }
            } catch (selectorError) {
              // Invalid selector, continue to next
              continue;
            }
          }
          
          return false;
        } catch (error) {
          console.warn('Error setting input value:', key, value, error);
          return false;
        }
      }



      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.optionId=='filter-price') {
                this.querySelector('#filter-price-min').value = '';
                this.querySelector('#filter-price-max').value = '';
              } else {
                if(button.dataset.clearAll) {
                  const newUrl = window.location.pathname;
                  window.location.href = newUrl;
                  return;
                } else {
                  this.querySelector('#'+button.dataset.optionId).checked = false;
                }
              }
              this.filterResults();
            });
          });
        }
      }

      getSearchParams() {
        try {
          const formData = new FormData(this.form);
          const searchParams = new URLSearchParams(formData);
          const params = new URLSearchParams();
          
          // Get unique keys and process them
          const keys = Array.from(new Set(searchParams.keys()));
          
          keys.forEach((key) => {
            try {
              let values = searchParams.getAll(key);
              // Robust empty value filtering
              values = values.filter(x => x != null && x.toString().trim() !== "");
              
              if (values.length > 0) {
                // Ensure proper encoding for filter parameters
                if (key.startsWith('filter.')) {
                  // Join multiple values with comma for Shopify filtering
                  const joinedValues = values.map(v => encodeURIComponent(v.trim())).join(',');
                  params.set(key, joinedValues);
                } else {
                  params.set(key, values.join(','));
                }
              }
            } catch (error) {
              console.warn('Error processing form key:', key, error);
            }
          });

          // Preserve important URL parameters
          const currentSearch = new URLSearchParams(location.search);
          const preserveParams = ['sort_by', 'page', 'q', 'view'];
          
          preserveParams.forEach(param => {
            if (currentSearch.has(param) && !params.has(param)) {
              params.set(param, currentSearch.get(param));
            }
          });

          return params;
        } catch (error) {
          console.error('Error building search params:', error);
          return new URLSearchParams();
        }
      }

      filterResults() {
        var params = this.getSearchParams();
        var paramsString = params.toString().replace(/%2C/g, ',');
        
        this.hideFilters();
        
        const newUrl = window.location.pathname + (paramsString ? '?' + paramsString : '');
        window.location.href = newUrl;
      }

      updateFilterCounts() {
        const counts = this.calculateFilterCounts();
        
        Object.keys(counts).forEach(key => {
          const countElement = this.querySelector(`[data-filter-count="${key}"]`);
          if (countElement && counts[key] !== undefined) {
            countElement.textContent = `(${counts[key]})`;
            countElement.style.display = counts[key] > 0 ? 'inline' : 'none';
          }
        });
      }

      calculateFilterCounts() {
        return {};
      }

      updateResultsCount() {
        const resultCountElement = document.getElementById('filter-results-count');
        const resultCountText = document.getElementById('results-count-text');
        
        if (resultCountElement && resultCountText) {
          const vueApp = document.querySelector('.collections.container[v-scope]');
          let totalCount = 0;
          
          if (vueApp) {
            const collections = vueApp.querySelectorAll('.collection');
            collections.forEach(collection => {
              const products = collection.querySelectorAll('.collection-product-card');
              totalCount += products.length;
            });
          }
          
          if (totalCount > 0) {
            resultCountText.textContent = `${totalCount} product${totalCount !== 1 ? 's' : ''} found`;
            resultCountElement.style.display = 'block';
          } else {
            resultCountElement.style.display = 'none';
          }
        }
      }

      updateClearButton() {
        const params = new URLSearchParams(window.location.search);
        const hasFilters = Array.from(params.keys()).some(key => key.startsWith('filter.'));
        const clearButton = document.getElementById('main-clear-filters');
        
        if (clearButton) {
          if (hasFilters) {
            clearButton.style.display = 'inline-flex';
          } else {
            clearButton.style.display = 'none';
          }
        }
      }

      clearAllFilters() {
        const newUrl = window.location.pathname;
        window.location.href = newUrl;
      }
    }
    customElements.define('collection-filters', CollectionFilters);
  }

  if(!customElements.get('collection-filters-tags')) {
    class CollectionFiltersTags extends CollectionFiltersAbstract {
      constructor() {
        super();
        this.baseUrl = location.origin + this.dataset.baseUrl;

        this.querySelectorAll('.item a').forEach((link)=>{
          link.addEventListener('click', (e)=>{
            e.preventDefault();
            this.filterResults(link.href);
          });
        });
        this.initSummary();
      }

      initSummary() {
        if(this.summary) {
          this.summary.querySelectorAll('button').forEach((button)=>{
            button.addEventListener('click', (e)=>{
              e.preventDefault();
              if(button.dataset.clearAll) {
                var url = new URL(this.baseUrl);
                var currentUrl = new URL(location.href);
                url.search = currentUrl.search;
                this.filterResults(url.toString());
              } else {
                this.querySelector('#'+button.dataset.optionId).closest('a').dispatchEvent(new Event('click', {bubbles: true}));
              }
            });
          });
        }
      }

      filterResults(url) {
        if(this.ajax) {
          $s.showLoadingOverlay();
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          });
        } else {
          location = url;
        }
      }
    }
    customElements.define('collection-filters-tags', CollectionFiltersTags);
  }
}

if(!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      this.pageManager = this.closest('page-manager');
      this.dropdown = this.querySelector('#sort-by');
      this.ajax = true;

      var search = new URLSearchParams(location.search)
      this.dropdown.value = search.get('sort_by') || this.dataset.sortBy;

      this.dropdown.addEventListener('change', ()=>{
        var search = new URLSearchParams(location.search); //get new instance
        search.set('sort_by', this.dropdown.value);
        search.delete('page');
        var paramsString = search.toString();

        if(this.ajax) {
          $s.showLoadingOverlay();
          const url = window.location.pathname + (paramsString ? '?'+paramsString : '');
          this.pageManager.loadPage(url, ()=>{
            $s.hideLoadingOverlay();
          });
        } else {
          location.search = paramsString;
        }
      });
    }
  }
  customElements.define('collection-sort', CollectionSort);
}